import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ParentPaper } from '../atoms/parent-paper';
import { SwitchBox } from '../molecules/switch-box';
import { Group } from '../organisms/group';
import { FormattedValue } from '../store/formatted-value';

const ProductTestProtocol = () => {
  return (
    <>
      <Group
        title={
          <FormattedMessage id="protocol.settings" defaultMessage="Nastavení" />
        }
        layout="list"
      >
        <ParentPaper>
          <SwitchBox
            title={
              <FormattedMessage
                id="protocol.settings.distribution"
                defaultMessage="Distribuce"
              />
            }
            subtitle={<FormattedValue variableId="OEM_DISTRIBUTION" />}
            fullWidth
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="protocol.settings.Licence"
                defaultMessage="Licence"
              />
            }
            subtitle={<FormattedValue variableId="LICENSE_STATUS" />}
            fullWidth
          />
        </ParentPaper>
      </Group>
      <Group
        title={
          <FormattedMessage id="protocol.test" defaultMessage="Test zařízení" />
        }
        layout="list"
      >
        <ParentPaper>
          <SwitchBox
            title={
              <FormattedMessage
                id="protocol.test.tester"
                defaultMessage="Zařízení otestoval"
              />
            }
            subtitle={<FormattedValue variableId="PRODUCT_TESTER" />}
            fullWidth
          />

          <SwitchBox
            title={
              <FormattedMessage
                id="protocol.test.inverter-connect"
                defaultMessage="Připojení střídače"
              />
            }
            subtitle={<FormattedValue variableId="TEST_INFO_LABEL[0]" />}
            fullWidth
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="protocol.test.internet-connect"
                defaultMessage="Připojení k internetu"
              />
            }
            subtitle={<FormattedValue variableId="TEST_INFO_LABEL[1]" />}
            fullWidth
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="protocol.test.phase_1"
                defaultMessage="Test 1. fáze"
              />
            }
            subtitle={<FormattedValue variableId="TEST_INFO_LABEL[2]" />}
            fullWidth
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="protocol.test.phase_2"
                defaultMessage="Test 2. fáze"
              />
            }
            subtitle={<FormattedValue variableId="TEST_INFO_LABEL[3]" />}
            fullWidth
          />
          <SwitchBox
            title={
              <FormattedMessage
                id="protocol.test.phase_3"
                defaultMessage="Test 3. fáze"
              />
            }
            subtitle={<FormattedValue variableId="TEST_INFO_LABEL[4]" />}
            fullWidth
          />
        </ParentPaper>
      </Group>
    </>
  );
};

export default ProductTestProtocol;
